import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Calendar from '../../shared/calendar/main';
import Filters from '../../shared/filters/main';
import Table from './components/table';

import wrapMain from '../wrap-main';

import { selectors, actions } from './';

import './index.less';
import SwitchControlSingleDecorator from '../../shared/switch-control/single/main';
import cn from 'classname';

function Main(props) {

	const { intl, filters, calendar, utms, changeUtm } = props;

	return (
		<div className='marketing-funnel-registration-activity'>
			<div className='marketing-funnel-registration-activity-actions'>
				<div className='marketing-funnel-registration-activity-filters clearfix'>
					<Filters
						intl={intl} {...filters} filters={filters} // for crutch support
					/>
				</div>
				<Calendar
					intl={intl}
					{...calendar}
					onInit={calendar.calendarInit}
					onToggle={calendar.calendarToggle}
					onChange={calendar.calendarChange}
					onApply={calendar.calendarApply}
				/>
				<button
					className='ui-btn ui-btn-primary'
					onClick={props.apply}
				>
					{intl('Apply')}
				</button>
				<button
					className='ui-btn ui-btn-primary'
					onClick={props.exportCsv}
				>
					{intl('Export')}
				</button>
				<button
					className='ui-btn ui-btn-secondary ui-icon-clear'
					onClick={props.clear}
				/>
			</div>
			<div className="margin-bottom-10">
				<SwitchControlSingleDecorator>
					{ utms.map(filter => (
						<button
							key={filter.name}
							onClick={() => changeUtm(filter.name)}
							className={cn('ui-btn ui-btn-secondary', filter.active && 'active')}>{ intl(filter.placeholder) }</button>
					)) }
				</SwitchControlSingleDecorator>
			</div>
			<div className="margin-bottom-10">
				<SwitchControlSingleDecorator>
					{ [true, false].map(filter => (
						<button
							key={`${filter}`}
							onClick={() => props.changeIsEmptyOnly(filter)}
							className={cn('ui-btn ui-btn-secondary', props.isNonEmptyOnly === filter && 'active')}
						>
							{ filter ? intl(`Is non empty only`) : intl(`All`) }
						</button>
					)) }
				</SwitchControlSingleDecorator>
			</div>
			<Table {...props} />
		</div>
	);
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		data: selectors.select(state, 'data'),
		utm: selectors.select(state, 'utm'),
		rows: selectors.getRows(state),
		totalAffsCount: selectors.getTotalAffsCount(state),
		affiliatesLoadingFromId: selectors.getAffiliatesLoadingFromId(state),
		sort: selectors.getSort(state),
		isNonEmptyOnly: selectors.getIsNonEmptyOnly(state),
		intervals: selectors.select(state, 'intervals'),
		// -----------------------------------------
		filters: selectors.getFilters(state),
		utms: selectors.getUtms(state),
		calendar: selectors.getCalendar(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		apply: () => dispatch(actions.apply()),
		clear: () => dispatch(actions.clear()),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(wrapMain(Main));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/registration-activity/main.js